import axios from 'axios'

export const CUSTOMER_URL = `${process.env.REACT_APP_API_URL}/CustomerDetails`;
export const CUSTOMER = `${process.env.REACT_APP_API_URL}/Customer`;

export const getCustomerDetailsByEmail = async (
  email: string
) => {
  try {
    const response = await axios.get(`${CUSTOMER_URL}/getcustomerbyemail`, {
      params: {
        email
      }
    })
    return response.data
  } catch (err) {
    return err
  }
}

export const getCustomerSearchQuery = async (searchTerm: string) => {
  try {
    const response = await axios.get(`${CUSTOMER}/customerSearchQuery/${searchTerm}`)
    return response.data
  } catch (err) {
    return err
  }
}